import SearchIcon from '@mui/icons-material/Search';
import { Box, LinearProgress, Pagination, PaginationItem } from '@mui/material';
import {
    DataGrid,
    GridColumns,
    GridSelectionModel,
    GridToolbarQuickFilter,
    gridPageCountSelector,
    gridPageSelector,
    useGridApiContext,
    useGridSelector,
} from '@mui/x-data-grid';
import React from 'react';
import colors from '../../../assets/theme/base/colors';
const { dark } = colors;

interface IProps {
    rows: any;
    columns: GridColumns<any>;
    isLoading: boolean;
    setSelectionModel: React.Dispatch<React.SetStateAction<GridSelectionModel>>;
    selectionModel: GridSelectionModel;
    pageSize?: number;
    checkboxSelection?: boolean;
}

export const UserDataTable = (props: IProps) => {
    function CustomPagination() {
        const apiRef = useGridApiContext();
        const page = useGridSelector(apiRef, gridPageSelector);
        const pageCount = useGridSelector(apiRef, gridPageCountSelector);

        return (
            <Pagination
                color="primary"
                shape="rounded"
                page={page + 1}
                count={pageCount}
                showFirstButton
                showLastButton
                // @ts-expect-error
                renderItem={(props2) => <PaginationItem {...props2} disableRipple />}
                onChange={(event: React.ChangeEvent<unknown>, value: number) =>
                    apiRef.current.setPage(value - 1)
                }
                variant="outlined"
                sx={{
                    '& .MuiPaginationItem-root': {
                        color: dark.main,
                        border: '1px solid rgb(222, 226, 230)',
                        borderRadius: '50%',
                        '&.Mui-selected': {
                            background: 'linear-gradient(195deg, rgb(119, 156, 170), rgb(9, 115, 132))',
                            color: '#fff',
                            border: 0,
                            boxShadow: 'rgba(9, 115, 132, 0.15) 0rem 0.1875rem 0.1875rem 0rem, rgba(9, 115, 132, 0.2) 0rem 0.1875rem 0.0625rem -0.125rem, rgba(9, 115, 132, 0.15) 0rem 0.0625rem 0.3125rem 0rem',
                        },
                        '&.MuiPaginationItem-ellipsis': {
                            border: 0,
                        },
                    },
                }}
            />
        );
    }

    function QuickSearchToolbar() {
        return (
            <Box display="flex" justifyContent="end" flexDirection="row" sx={{ margin: 1 }}>
                <GridToolbarQuickFilter
                    sx={{
                        padding: 1,
                        border: "1px solid #ccc",
                        borderRadius: "4px",
                        overflow: "hidden",
                        "& .MuiDataGrid-filterInput": {
                            border: "none",
                        },
                        width: '300px'
                    }}
                    InputProps={{
                        disableUnderline: true,
                        startAdornment: (
                            <SearchIcon sx={{ width: 24, height: 24 }} />
                        ),
                    }}
                />
            </Box>
        );
    }

    return (
        <DataGrid
            sx={{
                "& .MuiDataGrid-main": {
                    fontSize: '1rem',
                    fontWeight: 300
                },
                "& .MuiDataGrid-columnHeaderTitle": {
                    whiteSpace: "break-spaces",
                    lineHeight: 1
                },
                "& .MuiDataGrid-row:hover": {
                    backgroundColor: "transparent",
                },
                "& .MuiDataGrid-columnHeaders": {
                    backgroundColor: "var(--semantics-disabled, #E9ECEF)",
                    height: 56,
                    borderTopLeftRadius: 0,
                    borderTopRightRadius: 0
                },
                "& .MuiCheckbox-root .MuiSvgIcon-root":{
                    border: "0.0625rem solid #505B60"
                }
            }}
            autoHeight
            rows={props.rows}
            disableSelectionOnClick
            getRowId={(row) => row.ID || row.Id || row.id}
            columns={props.columns}
            loading={props.isLoading}
            rowHeight={40}
            rowsPerPageOptions={[10]}
            checkboxSelection={props.checkboxSelection}
            disableColumnMenu
            onSelectionModelChange={(newSelectionModel, details) => {
                props.setSelectionModel(newSelectionModel);
            }}
            selectionModel={props.selectionModel}
            components={{
                LoadingOverlay: LinearProgress,
                Toolbar: QuickSearchToolbar,
                Pagination: CustomPagination,
            }}
            componentsProps={{
                toolbar: {
                    showQuickFilter: true,
                    quickFilterProps: { debounceMs: 500 },
                },
            }}
            pageSize={props.pageSize ? props.pageSize : 25}
        />
    );
};
